import { DriverNotificationText } from "../../../ducks/app/notifications/types";
import { useTranslation } from "react-i18next";

const InAppTextNotification = ({
  notification,
}: {
  notification: DriverNotificationText;
}) => {
  const { t } = useTranslation("notifications");

  return <div>{t(notification.data.text as any)}</div>;
};

export default InAppTextNotification;
